module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_2.5a63269a.png";